export const filterId = 'splitByDays' as const
